<div class="tab-container">
    <div class="nav">
        <div *ngFor="let tab of tabs" [ngClass]="{active: tab == activeComponent}" class="nav-item" (click)="activateTab(tab)"> 
            {{tab.tabName}}
        </div>
    </div>
	<ng-template [ngTemplateOutlet]="activeComponent.templateRef" [ngTemplateOutletContext]=" {content: {}}"></ng-template>
</div>
